module.exports = __webpack_public_path__ + "static/media/logo-big.21fc072a.jpg";